__turbopack_context__.v({
  "animate": "Notifications-module-scss-module__mVY2jq__animate",
  "bottom": "Notifications-module-scss-module__mVY2jq__bottom",
  "closeIcon": "Notifications-module-scss-module__mVY2jq__closeIcon",
  "collapse": "Notifications-module-scss-module__mVY2jq__collapse",
  "content": "Notifications-module-scss-module__mVY2jq__content",
  "focus": "Notifications-module-scss-module__mVY2jq__focus",
  "loading": "Notifications-module-scss-module__mVY2jq__loading",
  "margin": "Notifications-module-scss-module__mVY2jq__margin",
  "noContent": "Notifications-module-scss-module__mVY2jq__noContent",
  "notifications": "Notifications-module-scss-module__mVY2jq__notifications",
  "open": "Notifications-module-scss-module__mVY2jq__open",
  "reveal": "Notifications-module-scss-module__mVY2jq__reveal",
  "seen": "Notifications-module-scss-module__mVY2jq__seen",
  "status": "Notifications-module-scss-module__mVY2jq__status",
  "tabs": "Notifications-module-scss-module__mVY2jq__tabs",
});
